<template>
  <div :set="(strength = humanFilterStrength(score))">
    <div
      :class="[
        'human-filters-score',
        { 'no-opacity': white_bg, 'bg-white': white_bg },
        `text-${strength.color}`,
      ]"
      :style="{
        backgroundColor: `rgba(${strength.hexColor.r}, ${strength.hexColor.g}, ${strength.hexColor.b}, 0.1)`,
      }"
    >
      <div :class="['label', strength.color]">{{ score }}</div>
    </div>
  </div>
</template>

<script>
import humanFilterStrength from "../../mixins/human-filters/human-filter-strength";

export default {
  name: "DHumanFiltersChip",
  mixins: [humanFilterStrength],
  props: {
    score: {
      type: Number,
      required: true,
    },
    white_bg: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.human-filters-score {
  padding: 4px 12px 4px 12px;
  border-radius: 50px;
  position: relative;

  &::before {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    border-radius: inherit;
    background-color: inherit;
    opacity: 0.1;
  }

  .label {
    font-size: 14px;
    font-weight: 600;
    line-height: 16px;
    letter-spacing: 0.2px;
  }
}
</style>
